import {ParamsModel} from 'src/app/modules/common/Model'
import {actionTypes} from './constants'

export const actions = {
  getFdType: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_FD_TYPE_START,
    payload: params,
  }),

  getFdTypeSuccess: (data: any) => ({
    type: actionTypes.GET_FD_TYPE_SUCCESS,
    payload: data,
  }),
  getFdTypeFinish: () => ({
    type: actionTypes.GET_FD_TYPE_FINISH,
  }),
  getFdTypeError: (error: unknown) => ({
    type: actionTypes.GET_FD_TYPE_FINISH,
    payload: {error},
  }),

  addFdType: (data: any) => ({
    type: actionTypes.ADD_FD_TYPE_START,
    payload: data,
  }),
  addFdTypeSuccess: (task: any) => ({
    type: actionTypes.ADD_FD_TYPE_SUCCESS,
    payload: task,
  }),
  addFdTypeFinish: () => ({
    type: actionTypes.ADD_FD_TYPE_FINISH,
  }),
  addFdTypeReset: () => ({
    type: actionTypes.ADD_FD_TYPE_RESET,
  }),

  updateFdType: (data: any, id: string) => ({
    type: actionTypes.UPDATE_FD_TYPE_START,
    payload: {data, id},
  }),
  updateFdTypeSuccess: (task: any) => ({
    type: actionTypes.UPDATE_FD_TYPE_SUCCESS,
    payload: task,
  }),
  updateFdTypeFinish: () => ({
    type: actionTypes.UPDATE_FD_TYPE_FINISH,
  }),
  updateFdTypeReset: () => ({
    type: actionTypes.UPDATE_FD_TYPE_RESET,
  }),

  deleteFdType: (data: any) => ({
    type: actionTypes.DELETE_FD_TYPE_START,
    payload: {fdTypeId: data},
  }),
  deleteFdTypeSuccess: (data: any) => ({
    type: actionTypes.DELETE_FD_TYPE_SUCCESS,
    payload: data,
  }),
  deleteFdTypeFinish: () => ({
    type: actionTypes.DELETE_FD_TYPE_FINISH,
  }),
  activateFdType: (id: any) => ({
    type: actionTypes.SINGLE_ACTIVATE_FD_TYPE_REQUEST,
    payload: {fdTypeId: id},
  }),
  deactivateFdType: (id: any) => ({
    type: actionTypes.SINGLE_DEACTIVATE_FD_TYPE_REQUEST,
    payload: {fdTypeId: id},
  }),
  singleActivateFdType: (id: any) => ({
    type: actionTypes.SINGLE_ACTIVATE_FD_TYPE_REQUEST,
    payload: {fdTypeId: [id]},
  }),
  singleDeactivateFdType: (id: any) => ({
    type: actionTypes.SINGLE_DEACTIVATE_FD_TYPE_REQUEST,
    payload: {fdTypeId: [id]},
  }),

  sortFdType: (data: any) => ({
    type: actionTypes.SORT_FD_TYPE_START,
    payload: data,
  }),
  sortFdTypeSuccess: (data: any) => ({
    type: actionTypes.SORT_FD_TYPE_SUCCESS,
    payload: data,
  }),
  sortFdTypeFinish: () => ({
    type: actionTypes.SORT_FD_TYPE_FINISH,
  }),
  sortFdTypeReset: () => ({
    type: actionTypes.SORT_FD_TYPE_RESET,
  }),
}
